import React from 'react';
import { ApplicationUser } from 'types';

import { EditTeamRow } from './components/EditTeamRow';
import { ViewTeamRow } from './components/ViewTeamRow';

interface ManageTeamRowProps {
  data: ApplicationUser;
  columnWidths: string;
  isAdmin?: boolean;
}

export const ManageTeamRow: React.FC<ManageTeamRowProps> = ({
  data,
  columnWidths,
  isAdmin = false,
}) => {
  const [isEditable, setEditable] = React.useState(false);

  return isEditable ? (
    <EditTeamRow data={data} isAdmin={isAdmin} setEditable={setEditable} />
  ) : (
    <ViewTeamRow
      data={data}
      isAdmin={isAdmin}
      columnWidths={columnWidths}
      setEditable={setEditable}
    />
  );
};
